import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../shared/services/http.service';
import { HttpClient } from '@angular/common/http';
import { encodeToBase64 } from '../../utility';

@Injectable({ providedIn: 'root' })
export class UsersService {
  private userList = `${environment.opbBackendHost}/api/admin/user/list`;
  private userUpdate = `${environment.opbBackendHost}/api/admin/user/update`;
  private userCreate = `${environment.opbBackendHost}/api/admin/user/create`;
  private userDelete = `${environment.opbBackendHost}/api/admin/user/remove`;
  private userDownload = `${environment.opbBackendHost}/api/admin/user/download`;
  private updateStatus = `${environment.opbBackendHost}/api/admin/user/status`;
  private designationsList = `${environment.opbBackendHost}/api/admin/user/designations`;
  private groups = `${environment.opbBackendHost}/api/admin/group/list`;
  private groupAllList = `${environment.opbBackendHost}/api/admin/group/list/all`;
  private ielGroups = `${environment.opbBackendHost}/api/admin/user/iel`;
  private ielList = `${environment.opbBackendHost}/api/admin/user/iel/list`;

  http=inject(HttpClient);
  httpService = inject(HttpService);

  getUsers(data: any): Observable<any> {
    return this.httpService.post(this.userList, data);
  }

  updateUsers(data: any): Observable<any> {
    return this.httpService.post(this.userUpdate, data);
  }

  addUsers(data: any): Observable<any> {
    return this.httpService.post(this.userCreate, data);
  }

  deleteUser(data: any): Observable<any> {
    return this.httpService.post(this.userDelete, data);
  }

  getDesignations(data: any): Observable<any> {
    return this.httpService.post(this.designationsList, data);
  }

  changeStatus(data: any): Observable<any> {
    return this.httpService.post(this.updateStatus, data);
  }

  getGroups(data: any): Observable<any> {
    return this.httpService.post(this.groups, data);
  }

  getAllGroups(data: any): Observable<any> {
    return this.httpService.post(this.groupAllList, data);
  }

  addIelGroup(data: any): Observable<any> {
    return this.httpService.post(this.ielGroups, data);
  }

  getIelGroup(data: any): Observable<any> {
    return this.httpService.post(this.ielList, data);
  }

  downloadUsers(payload: any): Observable<Blob> {
    const data = { payload: encodeToBase64(JSON.stringify(payload)) };
    return this.http.post(this.userDownload, data, {
      responseType: 'blob',
      withCredentials: true,
    });
  }
}
